import { render } from "./ImportantNotes.vue?vue&type=template&id=5e5035a4"
import script from "./ImportantNotes.vue?vue&type=script&lang=js"
export * from "./ImportantNotes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__